import fetch from '../../app/utils/fetch';
import { cmxURL } from 'endpoints';
import { setLanguageBundle } from '@nackle/intl-tools';
import { DEFAULT_LOCALE_CODE } from '../constants';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    error: '',
    loading: false,
    user: {}
};

/*******************************************************************************
 * Non-async action types
 */
export const LOADING_START = 'loading/start';
export const LOADING_END   = 'loading/end';
export const SET_ERROR = 'state/setError';
export const CLEAR_ERROR = 'state/clearError';
const SET_USER_DETAILS   = 'state/setUserDetails';

/*******************************************************************************
 * Reducer
 */
export default function appReducer( state = initialState, action ) {
    switch ( action.type ) {
        case LOADING_START: {
            return {
                ...state,
                loading: true
            };
        }
        case LOADING_END: {
            return {
                ...state,
                loading: false
            };
        }
        case SET_ERROR: {
            return {
                ...state,
                error: action.data
            };
        }
        case CLEAR_ERROR: {
            return {
                ...state,
                error: []
            };
        }
        case SET_USER_DETAILS: {
            return {
                ...state,
                user: action.user
            };
        }
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
export const startLoading = ( ) => ( { type: LOADING_START } );

export const endLoading = ( ) => ( { type: LOADING_END } );

export const setError = data => ( { type: SET_ERROR, data } );

export const clearError = ( ) => ( { type: CLEAR_ERROR } );

export const setUserDetails = ( user ) => {
    return {
        type: SET_USER_DETAILS,
        user
    };
};

export const loadBundles = ( bundleNames, locale = DEFAULT_LOCALE_CODE ) => async () => {
    const bundleData = await Promise.all( bundleNames.map(
        bundleName => getBundle( bundleName, [ locale ] )
    ) );

    let mergedBundle = bundleData[ 0 ].bundles[ locale ];
    for ( let i = 1; i < bundleData.length; i++ ) {
        mergedBundle = {
            ...mergedBundle,
            ...bundleData[ i ].bundles[ locale ]
        };
    }

    await setLanguageBundle( locale, mergedBundle );
    return mergedBundle;
};

const getBundle = async ( bundleName, locales ) => {
    const res = await fetch(
        `${ cmxURL }/bundle/${ encodeURIComponent( bundleName ) }`,
        {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify( { locales } )
        }
    );

    const data = await res.json();

    if ( res.ok ) {
        return data;
    } else {
        throw data;
    }
};